import React, { useEffect, useState } from "react";
import { compose, withAppContext, withActions, withState } from "containers/HOC";
import * as utils from "common/utils";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import Alert from "components/Alert";
import { confirm } from "containers/App/_actions";
import { revokeFarmAccessInvitation } from "../Farm/_actions";
import ActionLink from "components/ActionLink";
import { getAccessInvitations } from "./_actions";
import { modal } from "containers/App/_actions";
import { Link } from "react-router-dom";

const MyPendingFarmAccessRequests = ({ online, pendingAccessInvitations, getAccessInvitations, confirm, refData, modal, authContext, pendingAccessInvitationsLoading, revokeFarmAccessInvitation }) => {
    const [refreshCount, setRefreshCount] = useState(0);

    useEffect(() => {
        if (refreshCount === 0) {
            getAccessInvitations();
        } else if (refreshCount > 0 && refreshCount < 10) {
            setTimeout(() => {
                getAccessInvitations();
                setRefreshCount(refreshCount + 1);
            }, 5000);
        }
        return () => {
            setRefreshCount(10);
        };
    }, [getAccessInvitations, refreshCount]);

    if (!pendingAccessInvitations || pendingAccessInvitations.length === 0) return null;

    const onResendComplete = (vm) => {
        setRefreshCount(1);
    };

    const resend = (accessInvitation) => (e) => {
        if (!accessInvitation) return;
        const canInviteOwner = accessInvitation.role === "Owner" || authContext.isSystemAdmin;
        modal("GrantFarmAccessModal", onResendComplete, { ...accessInvitation, canInviteOwner, farmId: accessInvitation.farmId });
    };

    const revokeFarmAccessInvitationHandler = (access) => {
        revokeFarmAccessInvitation(access.id, access.farmId, getAccessInvitations());
    };

    const _revokeInvite = (access) => {
        confirm(`Are you sure you want to delete this invitation?`, () => revokeFarmAccessInvitationHandler(access), false);
    };

    return (
        <Panel title={`My Pending farm access invitations (${pendingAccessInvitations.length})`} skyBlue iconClassName="IconLink--clock" loading={online && pendingAccessInvitationsLoading && refreshCount === 0} stickyHeaderName="dashboard.farmaccessinvites.collapsed">
            <Alert type="info" text="The list of people you have invited to farms. The email status shows if the email has been sent successfully to the recipient or not. If an email has not been sent successfully please check the email address is spelt correctly." />
            <PanelBody>
                <div className="Table">
                    <table>
                        <thead>
                            <tr>
                                <th>Farm</th>
                                <th>Email Status</th>
                                <th>Email</th>
                                <th>Date</th>
                                <th>Role</th>
                                <th>Invited by</th>
                                {online && <th className="th--shrink"></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {pendingAccessInvitations
                                .sort((a, b) => (b.farmName < a.farmName ? 1 : -1))
                                .map((accessInvitation, i) => {
                                    const { emailLog } = accessInvitation;
                                    const status = emailLog ? emailLog.status : "Unknown";

                                    return (
                                        <tr key={accessInvitation.id} id={accessInvitation.id} className={emailLog && emailLog.failed ? "u-font-red u-font-600" : ""}>
                                            <td valign="top" id={`farmname_${accessInvitation.inviteeEmail}`}>
                                                <Link to={`/app/farm/${accessInvitation.farmId}`} className="u-link u-textBold">
                                                    {accessInvitation.farmName}
                                                </Link>
                                                <br />
                                                {accessInvitation.farmAddress}
                                            </td>
                                            <td id={`status_${accessInvitation.inviteeEmail}`}>{status}</td>
                                            <td id={`invitee_${accessInvitation.inviteeEmail}`}>{accessInvitation.inviteeEmail}</td>
                                            <td id={`date_${accessInvitation.inviteeEmail}`}>{utils.dateOnly(accessInvitation.invitedOn)}</td>
                                            <td id={`account_${accessInvitation.inviteeEmail}`}>{utils.valueToText(refData.farmRoles, accessInvitation.role)}</td>
                                            {accessInvitation.invitedBy.accountName !== accessInvitation.invitedBy.userFullName ? (
                                                <td>
                                                    {accessInvitation.invitedBy.accountName} - {accessInvitation.invitedBy.userFullName}
                                                </td>
                                            ) : (
                                                <td>{accessInvitation.invitedBy.accountName}</td>
                                            )}
                                            {online && (
                                                <td>
                                                    <div className="u-flex">
                                                        {accessInvitation.status !== "Granted" && (
                                                            <ActionLink className="IconLink--edit" id={`resend-${accessInvitation.id}`} onClick={resend(accessInvitation)}>
                                                                Resend
                                                            </ActionLink>
                                                        )}
                                                        {
                                                            <ActionLink className="IconLink--cross-circle u-ml-sm" id={`revoke-${accessInvitation.id}`} onClick={(e) => _revokeInvite(accessInvitation)}>
                                                                Delete
                                                            </ActionLink>
                                                        }
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                </div>
            </PanelBody>
        </Panel>
    );
};

export default compose(
    withAppContext,
    withState((state, ownProps) => {
        return {
            pendingAccessInvitations: state.dashboard.accessInvitations,
            pendingAccessInvitationsLoading: state.dashboard.accessInvitationsLoading,
        };
    }),
    withActions({ confirm, revokeFarmAccessInvitation, getAccessInvitations, modal })
)(MyPendingFarmAccessRequests);
